import { createSelector } from '@reduxjs/toolkit';

import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';
import { projectSelector } from 'src/selectors/project';

export const diagramSnapshotSelector = memoizeSelectorFactory(
  (projectId: string) =>
    createSelector(
      projectSelector(projectId),
      (project) => project?.diagram || null
    )
);

export const isDraftDiagramSelector = memoizeSelectorFactory(
  (projectId: string) =>
    createSelector(diagramSnapshotSelector(projectId), (diagram) =>
      Boolean(diagram?.model.modelData.draftData)
    )
);
